import FeatureHistoryTopNavContainer from './FeatureHistoryTopNavContainer'

export default FeatureHistoryTopNavContainer
